
import { defineComponent, PropType, reactive, toRefs, watch } from "vue";
interface ParseListType {
  question?: string;
  userAnswer?: string;
  userTitle?: string;
  correctTitle?: string;
  correctValue?: string;
  detail?: string;
  message?: string;
}
export default defineComponent({
  props: {
    list: {
      type: Object as PropType<ParseListType>,
      default: [],
    },
  },
  setup(props) {
    const state = reactive({
      parseAnswerList: props.list,
    });
    watch(
      () => props.list,
      (val) => {
        state.parseAnswerList = val;
      }
    );
    return {
      ...toRefs(state),
    };
  },
});
